import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartBar } from '@fortawesome/free-solid-svg-icons';
import { Bar } from 'react-chartjs-2';
import { DataContext } from '../contexts/DataContext';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const CustomerTrafficReferenceCard = () => {
  const { data, isLoading } = useContext(DataContext);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!data) {
    return <div>No data available</div>;
  }

  // Process the data to count unique traffic_references per customer
  const trafficCounts = data.reduce((acc, item) => {
    const customerName = item.customer_data.customer_name;
    if (!acc[customerName]) {
      acc[customerName] = new Set();
    }
    acc[customerName].add(item.traffic_reference);
    return acc;
  }, {});

  const chartData = {
    labels: Object.keys(trafficCounts),
    datasets: [
      {
        label: 'Unique Traffic References per Customer',
        data: Object.values(trafficCounts).map(set => set.size),
        backgroundColor: '#4B77BE',
        hoverBackgroundColor: '#354A5F',
      },
    ],
  };

  const options = {
    indexAxis: 'y',
    maintainAspectRatio: false,
    scales: {
      x: {
        beginAtZero: true,
      },
    },
    plugins: {
      legend: {
        position: 'bottom',
      },
    },
  };


  return (
    <div className="bg-white shadow rounded-lg p-4 w-full max-w-lg flex flex-col justify-between h-custom-card-big overflow-y-auto">
      <div className="mb-4">
        <h2 className="text-lg font-bold text-gray-800 flex items-center">
          <FontAwesomeIcon icon={faChartBar} className="text-blue-600 mr-2" />
          Customer Traffic References
        </h2>
      </div>
      <div className="flex-grow relative h-full"> {/* Adjusted to fill available height */}
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
  
  
};

export default CustomerTrafficReferenceCard;
